import * as React from 'react';

const { useEffect, useRef } = React;

export const useMounted = (fn?: any) => {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current && fn) {
      fn();
    }
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted.current;
};



// WEBPACK FOOTER //
// ./src/services/hooks/useMounted.ts